import React, { useState, useEffect, memo } from "react";

interface SystemJobTimerProps {
  createdAt: string | number;
}

// Format elapsed time
const formatElapsedTime = (startTime: string | number) => {
  const now = Date.now();
  const elapsedSeconds = Math.floor(
    (now - new Date(startTime).getTime()) / 1000
  );
  return `${elapsedSeconds}s`;
};

// Memoized component that manages its own timer state
export const SystemJobTimer = memo(({ createdAt }: SystemJobTimerProps) => {
  const [elapsedTime, setElapsedTime] = useState(formatElapsedTime(createdAt));

  useEffect(() => {
    // Update immediately
    setElapsedTime(formatElapsedTime(createdAt));

    // Update every second
    const interval = setInterval(() => {
      setElapsedTime(formatElapsedTime(createdAt));
    }, 1000);

    return () => clearInterval(interval);
  }, [createdAt]);

  return (
    <span className="text-xs text-slate-500 dark:text-slate-400">
      {elapsedTime}
    </span>
  );
});

SystemJobTimer.displayName = "SystemJobTimer";

